"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6835],{

/***/ 16835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ BannerImage1; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/banner2.jpeg
/* harmony default export */ var banner2 = ({"src":"/_next/static/media/banner2.3d247b60.jpeg","height":558,"width":2388,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAACAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAbEAACAgMBAAAAAAAAAAAAAAABAgADBBESYf/EABQBAQAAAAAAAAAAAAAAAAAAAAP/xAAWEQEBAQAAAAAAAAAAAAAAAAAAATH/2gAMAwEAAhEDEQA/AKMequzBoV0Vgj3KoYb5HO9DyIiHC3X/2Q==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/Banner2Lowres.jpeg
/* harmony default export */ var Banner2Lowres = ({"src":"/_next/static/media/Banner2Lowres.69d07dcc.jpeg","height":164,"width":700,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAACAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAbEAACAwEBAQAAAAAAAAAAAAACAwABEQQSYf/EABQBAQAAAAAAAAAAAAAAAAAAAAP/xAAWEQEBAQAAAAAAAAAAAAAAAAAAATH/2gAMAwEAAhEDEQA/AKeZS2cXMJrE6BjhGircrzuV8iIhwl1//9k=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/MobileBanner2.jpeg
/* harmony default export */ var MobileBanner2 = ({"src":"/_next/static/media/MobileBanner2.53482b2d.jpeg","height":625,"width":1965,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAH/xAAdEAABBAIDAAAAAAAAAAAAAAACAAEDBBESBSFB/8QAFAEBAAAAAAAAAAAAAAAAAAAAAv/EABkRAAIDAQAAAAAAAAAAAAAAAAACARFxQf/aAAwDAQACEQMRAD8AtsRg469VABeGvKzxBILHo+uets+oiIp3RPNVh//Z","blurWidth":8,"blurHeight":3});
// EXTERNAL MODULE: ./src/qualification/hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(19916);
;// CONCATENATED MODULE: ./src/static_pages/home/variationB/components/BannerImage2.tsx








function BannerImage1() {
    var mobile = (0,useBreakpoints/* useBreakpointDown */.a)("sm");
    var ref = (0,react.useState)(false), loaded = ref[0], setLoaded = ref[1];
    var handleLoad = function() {
        setLoaded(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
        children: mobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                position: "relative",
                width: "100%",
                height: "201px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: MobileBanner2,
                layout: "fill",
                objectFit: "cover",
                objectPosition: "center",
                priority: true,
                alt: ""
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: loaded ? banner2 : Banner2Lowres,
            quality: 100,
            onLoadingComplete: handleLoad,
            placeholder: "blur",
            objectFit: "cover",
            alt: "",
            blurDataURL: Banner2Lowres.src
        })
    });
}


/***/ })

}]);